import PageLayout from "../../components/common/page-layout";
import CompanyAccountTypePanel from "../../components/company-account-type/company-account-type-panel";
import CompanyConfigurations from "../../components/company-configurations/company-configurations";
import { RequireAuth } from "../../hooks/use-auth";

/** Route page for per-company operational settings. */
const CompanyConfigurationsPage = () => {
  return (
    <RequireAuth>
      <PageLayout maxWidth={false} title="Company configurations">
        <CompanyConfigurations />
        <CompanyAccountTypePanel />
      </PageLayout>
    </RequireAuth>
  );
};

export default CompanyConfigurationsPage;
